import { render, staticRenderFns } from "./ServiceProfilePage.vue?vue&type=template&id=30b63c9c&"
import script from "./ServiceProfilePage.vue?vue&type=script&lang=js&"
export * from "./ServiceProfilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports